import React from "react";
import ComingSoon from "../../../subComponents/ComingSoon";

const Payments = () => {
  return <ComingSoon />;
};

export default Payments;
